import React, { useState } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DocumentDetails = ({ setDocumentsList, documentsList }) => {

    const initialState = {
        type: null,
        IssueDate: null,
        documentNo: '',
        file: null,
        expiryDate: null,
        Remarks: '',
        verified: false,
    };

    const [formData, setFormData] = useState(initialState);
    const [editIndex, setEditIndex] = useState(null);

    const contactTypes = [
        { label: "Office", value: "Office" },
        { label: "Office Phone", value: "Office Phone" },
        { label: "Office Fax", value: "Office Fax" },
        { label: "Res Phone", value: "Res Phone" },
        { label: "Res Fax", value: "Res Fax" },
        { label: "Mobile No", value: "Mobile No" },
        { label: "Rep Office Phone", value: "Rep Office Phone" },
        { label: "Rep Res Phone", value: "Rep Res Phone" },
        { label: "Rep Fax", value: "Rep Fax" },
        { label: "Rep Mobile", value: "Rep Mobile" },
    ];

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "file") {
            setFormData(prev => ({ ...prev, file: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSelectChange = (selected) => {
        setFormData(prev => ({ ...prev, type: selected }));
    };

    const handleDateChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddOrUpdate = () => {
        if (!formData.type || !formData.documentNo || !formData.IssueDate || !formData.expiryDate) {
            return;
        }

        if (editIndex !== null) {
            const updated = [...documentsList];
            updated[editIndex] = formData;
            setDocumentsList(updated);
            setEditIndex(null);
        } else {
            setDocumentsList(prev => [...prev, formData]);
        }

        setFormData(initialState);
    };

    const handleEdit = (index) => {
        setFormData({
            ...documentsList[index],
            file: null, // file input cannot be prefilled
        });
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setDocumentsList(documentsList.filter((_, i) => i !== index));
    };

    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }) : "";

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr))', gap: '20px' }}>
                    <div className="d-flex gap-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="taxInclusive"
                            style={{ width: '20px', height: '20px' }}
                            checked={formData.verified}
                            onChange={(e) => setFormData(prev => ({ ...prev, verified: e.target.checked }))}
                        />
                        <label className="form-check-label" htmlFor="taxInclusive">
                            Document Verified
                        </label>
                    </div>
                    <div></div>
                    <div></div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Document Type</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={contactTypes}
                            value={formData.type}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={handleSelectChange}
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Issue Date *</label>
                        <DatePicker
                            selected={formData.IssueDate}
                            onChange={(date) => handleDateChange({ name: 'IssueDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Document No *</label>
                        <input
                            type="number"
                            className="p-2 form-control w-75"
                            name="documentNo"
                            value={formData.documentNo}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">File</label>
                        <input
                            type="file"
                            className="p-2 form-control w-75"
                            name="file"
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Expiry Date *</label>
                        <DatePicker
                            selected={formData.expiryDate}
                            onChange={(date) => handleDateChange({ name: 'expiryDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Remarks</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="Remarks"
                            value={formData.Remarks}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className='my-4'>
                    <div className='mainbtnSecondary flex-end gap-2 col-2' onClick={handleAddOrUpdate}>
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update File" : "Add File"}
                        </div>
                    </div>
                </div>

                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Action</th>
                                <th>Document Type</th>
                                <th>Document No</th>
                                <th>Expiry Date</th>
                                <th>Issue Date</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documentsList.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center d-flex gap-3">
                                        <FaEdit size={20} onClick={() => handleEdit(index)} />
                                        <FaTrash size={20} color="red" onClick={() => handleDelete(index)} />
                                    </td>
                                    <td>{data.type?.label}</td>
                                    <td>{data.documentNo}</td>
                                    <td>{formatDate(data.expiryDate)}</td>
                                    <td>{formatDate(data.IssueDate)}</td>
                                    <td>{data.Remarks}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default DocumentDetails;
